import { render, staticRenderFns } from "./Cantidad.vue?vue&type=template&id=119c8bd2"
import script from "./Cantidad.vue?vue&type=script&lang=ts"
export * from "./Cantidad.vue?vue&type=script&lang=ts"
import style0 from "./Cantidad.vue?vue&type=style&index=0&id=119c8bd2&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports